import { useClientPortalAPI } from "@certn/api";
import { Loader } from "@certn/cascadia-react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { usePermissions } from "../../../components/permissions/PermissionsProvider";
import { NoAPIConfiguration } from "./NoAPIConfiguration";

export function APIConfigurationList() {
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();
  const canConfigureAts = hasPermission({
    action: "configure",
    target: "ats_integration",
    scope: "all",
  });

  const { data, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/public-api/api-configurations/"
  );
  const apiConfigurations = data?.results;

  useEffect(() => {
    if (apiConfigurations && apiConfigurations.length > 0) {
      if (canConfigureAts) {
        navigate(`${apiConfigurations[0].id}/ats-integrations`);
      } else {
        navigate(apiConfigurations[0].id);
      }
    }
  }, [apiConfigurations, canConfigureAts, navigate]);

  return isLoading ? <Loader /> : <NoAPIConfiguration />;
}
